import React from "react";
import ContactListsTable from "./ContactListTable/ContactListTable";
import {useCreateEmailListMutation, useGetEmailListsQuery} from "../../../services/emailListApi";

export default function EmailListSmart() {
  const {data: all = []} = useGetEmailListsQuery();
  const [createEmailListApi] = useCreateEmailListMutation();

  return <ContactListsTable
    emailLists={all}
    createEmailList={createEmailListApi}
  />


}